export const LOGIN = 'Login'
export const FETCH_AUTH_ROLES_DATA = 'fetchAuthRolesData'
export const FETCH_CLINICIAN_DATA = 'fetchClinicianData'
export const FETCH_INDIVIDUAL_CLINICIAN_DATA = 'fetchIndividualClinicianData'
export const CREATE_CLINICIAN_DATA = 'createClinicianData'
export const UPDATE_CLINICIAN_DATA = 'updateClinicianData'
export const FETCH_PATIENT_DATA = 'fetchPatientData'
export const FETCH_INDIVIDUAL_PATIENT_DATA = 'fetchIndividualPatientData'
export const CREATE_PATIENT_DATA = 'createPatientData'
export const UPDATE_PATIENT_DATA = 'updatePatientData'
export const FETCH_OPEN_PATIENT_DATA = 'fetchOpenPatientData'
export const CREATE_OPEN_PATIENT_DATA = 'createOpenPatientData'
export const VALIDATE_PATIENT = 'validatePatient'
export const FETCH_PATIENT_VIDEOS = 'fetchPatientVideos'
export const ACKNOWLEDGE_VIDEO = 'acknowledgeVideo'
export const SEND_SURVEY_DATA = 'sendSurveyData'
export const FETCH_USER_DATA = 'fetchUserData'
export const FETCH_INDIVIDUAL_USER_DATA = 'fetchIndividualUserData'
export const CREATE_USER_DATA = 'createUserData'
export const UPDATE_USER_DATA = 'updateUserData'
export const FETCH_PROCEDURE_DATA = 'fetchProcedureData'
export const FETCH_INDIVIDUAL_PROCEDURE_DATA = 'fetchIndividualProcedureData'
export const FETCH_SURVEYS_DATA = 'fetchSurveyData'
export const FETCH_INDIVIDUAL_SURVEY_DATA = 'fetchIndividualSurveyData'
export const FETCH_EDUCATION_DATA = 'fetchEducationData'
export const FETCH_INDIVIDUAL_EDUCATION_DATA = 'fetchIndividualEducationData'
export const FETCH_ROLE_DATA = 'fetchRoleData'
export const FETCH_AGREEMENT_DATA = 'fetchAgreementData'
export const FETCH_ORGANIZATION_NAME_DATA = 'fetchOrganizationNameData'
export const UPDATE_NEW_USER_PASSWORD = 'updateNewUserPassword'
export const FETCH_ORGANIZATION_DATA = 'fetchOrganizationData'
export const PATIENT_SEND_FITBIT_LINK = 'patientSendFitbitLink'
export const PATIENT_FOLLOW = 'patientFollow'
export const FETCH_FITBIT_DATA = 'fetchFitbitData'
export const CREATE_FITBIT_DATA = 'createFitbitData'
export const SETUP_FITBIT_AUTH = 'setupFitbitAuth'
export const FETCH_KIOSK_MODE_DATA = 'fetchKioskModeData'
export const RESET_STATE = 'resetstate'
export const RESET_AUTH_STATE = 'resetAuthState'
export const RESET_GLOBAL_STATE = 'resetGlobalState'
export const FETCH_TIME_TRACKING_DATA = 'fetchTimeTrackingData'
export const CREATE_TIME_TRACKING_DATA = 'createTimeTrackingData'
export const CANCEL_TIME_TRACKING_DATA = 'cancelTimeTrackingData'
export const DELETE_TIME_TRACKING_DATA = 'deleteTimeTrackingData'
export const EDIT_TIME_TRACKING_DATA = 'editTimeTrackingData'
export const FETCH_AVAILABLE_ORGANISATION = 'fetchAvailableOrganisation'
export const FETCH_LOGIN_USER_DETAILS = 'fetchLoginUserDetails'
export const FETCH_DEVICE_DATA = 'fetchDeviceData'
export const ADD_DEVICE_DATA = 'addDeviceData'
export const DELETE_DEVICE_DATA = 'deleteDeviceData'
export const FETCH_FHIR_ORG_FOR_CLIENT_DATA = 'fetchFhirOrgForClientData'
export const FETCH_FHIR_ORG_REG_DATA = 'fetchFhirOrgRegisterData'
export const FETCH_FHIR_ORG_DATA = 'fetchFhirOrgData'
export const FETCH_FHIR_PHYSICIAN_DATA = 'fetchFhirPhysicianData'
export const FETCH_FHIR_PATIENT_DATA = 'fetchFhirPatientData'
export const FETCH_FHIR_PHYSICIAN_MAPPING_DATA = 'fetchFhirPhysicianMappingData'
export const FETCH_FHIR_PATIENT_MAPPING_DATA = 'fetchFhirPatientMappingData'
export const UPDATE_FHIR_PATIENT_DATA = 'updateFhirPatientData'
export const UPDATE_FHIR_PHYSICIAN_DATA = 'updateFhirPhysicianData'
export const CREATE_FHIR_PATIENT_DATA = 'createFhirPatientData'
export const CREATE_FHIR_PHYSICIAN_DATA = 'createFhirPhysicianData'
export const FETCH_AVAILABLE_ADMIN_DEVICE = 'fetchAvailableAdminDevices'
export const FETCH_ORGANISATION_FEATURES = 'fetchOrganizationFeatures'
export const SAVE_USER_PREFERENCES = 'saveUserPreferences'
export const FETCH_CHARTS_DATA = 'fetchChartsData'
export const FETCH_COMPLIANCE_DATA = 'fetchComplianceData'
export const FETCH_COMPLIANCE_REPORTS_DATA = 'fetchComplianceReportsData'
export const CREATE_CARE_PLAN = 'createCarePlan'
export const FETCH_CARE_PLAN = 'fetchCarePlan'
export const FETCH_PROCEDURE_CATEGORY = 'fetchProcedureCategory'
export const FETCH_APPOINTMENT_DATA = 'fetchAppointmentData'
export const FETCH_RECENT_APPOINTMENT_DATA = 'fetchRecentAppointmentData'
export const FETCH_CLINICIAN_PATIENT_DATA = 'fetchClinicianPatientData'
export const FETCH_PATIENT_ALERTS_HISTORY_DATA = 'fetchPatientAlertsHistoryData'
export const PATIENT_ALERT_FORWARD_EMAIL = 'patientAlertForwardEmail'
export const PATIENT_ALERT_ADD_NOTES = 'patientAlertAddNotes'